import React from 'react'
import Breadcrumb from '../breadCrumb/BreadCrumb'
import Client from '../container/home/homeClient/Client'
import OurClientOne from '../container/ourClient/OurClientOne'
import OurClientThree from '../container/ourClient/OurClientThree'
import OurCLientTwo from '../container/ourClient/OurCLientTwo'
import Footer from '../footer/Footer'
import SEO from '../seo/SEO'
import TopNav from '../topNav/TopNav'

function OurClient() {
    return (
        <>
            <SEO title="Royality Technologies || Our Clients" />
            <TopNav />
            <Breadcrumb title="Home" content="Our Clients" image="/images/home/slide2.jpg" />
            <OurCLientTwo />
            <OurClientOne />
            <Client />
            <OurClientThree />
            <Footer />
        </>
    )
}

export default OurClient